import { render, staticRenderFns } from "./AdminPointTaskDetail.vue?vue&type=template&id=2f0de2d7&scoped=true"
import script from "./AdminPointTaskDetail.vue?vue&type=script&lang=js"
export * from "./AdminPointTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminPointTaskDetail.vue?vue&type=style&index=0&id=2f0de2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0de2d7",
  null
  
)

export default component.exports